import type { ReactNode } from "react";
import { AuthProvider } from "./AuthContext";
import { ToastProvider } from "src/components/Toast";

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return (
    <AuthProvider>
      <ToastProvider>{children}</ToastProvider>
    </AuthProvider>
  );
};
